export function unwrapError(err) {
  if (!err) return err;

  if (err.response && err.response.data) {
    return err.response.data;
  }
  return err;
}
